<div class="iq-customizer" [ngStyle]="{'right': leftPos ? '0px':'-300px'}">
    <button class="btn btn-primary themeBtn d-none" (click)="settingPannel()"><i class="fas fa-cog"></i></button>
    <div class="panelBody">
        <ul class="nav nav-tabs border-0" role="tablist">
            <li class="nav-item" role="presentation">
                <a class="nav-link active rounded-0" data-bs-toggle="tab" href="#theme" aria-selected="true" role="tab">Theme</a>
            </li>
            <li class="nav-item" role="presentation">
                <a class="nav-link rounded-0" data-bs-toggle="tab" href="#layout" aria-selected="false" role="tab" tabindex="-1">Layout</a>
            </li>
            <li class="nav-item" role="presentation">
                <a class="nav-link rounded-0" data-bs-toggle="tab" href="#more" aria-selected="false" role="tab" tabindex="-1">More</a>
            </li>
        </ul>
        <div id="myTabContent" class="tab-content">
            <div class="tab-pane fade active show" id="theme" role="tabpanel">
                <ul class="list-group">
                    <li class="list-group-item pr-3 pl-2 pb-2">
                        <a href="javascript:void(0)">Select Theme</a>
                        <select class="custom-select_ form-control" (change)="themeService.themeChange($event.target.value)">
                            <option *ngFor="let theme of generalTheme; let i = index" [value]="i"
                                [selected]="themeService.selectedTheme_id == theme.theme_id">{{theme.theme_name}}
                            </option>
                        </select>
                    </li>
                    <li class="list-group-item color_scheme">
                        <a href="javascript:void(0)">Color Scheme</a>
                        <ul class="ul-custom-select" id="colorScheme">
                            <li *ngFor="let thColor of themeService.selectedColorScheme" [ngClass]="{'active': themeService.themeColorScheme === thColor.color_scheme}">
                                <div class="actionPlate actionLink" (click)="themeService.changeColorScheme(thColor.color_scheme, true)">
                                    <span class="mainCd border-box" *ngFor="let subItem of thColor.theme_data ">
                                        <span [style.background]="color.value" class="cPZone-cover "
                                            (click)="themeService.changeColor1($event, color.key)"
                                            *ngFor="let color of subItem | keyvalue">
                                            <span class="badge badge-pill">
                                            </span>
                                    </span>
                                    </span>
                                </div>
                                <div class="actionPlate colorModifire d-none">
                                    <span class="mainCd" *ngFor="let subItem of thColor.theme_data ">
                                        <span class="cPZone-cover" *ngFor="let color of subItem | keyvalue">
                                            <span [ngStyle]="{'background-color': color.value}"
                                                class="badge badge-pill cPZone-1">
                                                <!-- <input type="color"  /> -->
                                                <span [(colorPicker)]="color.value"
                                                    (colorPickerChange)="themeService.changeColor1($event, color.key)"
                                                    [cpSaveClickOutside]="'false'" [cpCloseClickOutside]="'true'"
                                                    [style.background]="color.value" [cpPosition]="'bottom'"
                                                    [cpPositionRelativeToArrow]="'false'" [cpCancelButton]="'true'"
                                                    [cpOKButton]="'true'" [cpOutputFormat]="'rgba'"
                                                    class="colorPicker1 form-control-plaintext">
                                                </span>
                                    </span>
                                    </span>
                                    </span>

                                </div>
                            </li>
                        </ul>
                    </li>

                    <ng-container *ngFor="let theme of rightside_variables">
                        <li class="list-group-item" (click)="toggleMenu(theme.section_name)">
                            <a href="javascript:void(0)" class="ml-2">{{theme.section_name}}</a>
                            <div class="hiddenMenu" *ngIf="subsetting == theme.section_name && toggle" (click)="$event.stopPropagation()">

                                <div class="form-inline" *ngFor="let input of theme.section_fields">
                                    <div class="form-group ml-auto">
                                        <label for="{{input.id}}" class="mr-4">{{input.label}}</label>
                                        <div class="input-zone">
                                            <!-- <span *ngIf="input.inputType=='color'">
                                                <input type="color"
                                                    (change)="changeColor($event.target.value, input['name'])"
                                                    [style.color]="input['--value']" (colorPickerOpen)="'openDialog()'"
                                                    class="colorPicker" />
                                            </span> -->
                                            <span *ngIf="input.inputType=='color'" [(colorPicker)]="input['--value']" (colorPickerChange)="changeColor($event, input['name'])" [cpSaveClickOutside]="'false'" [cpCloseClickOutside]="'true'" [style.background]="input['--value']" [style.color]="input['--value']"
                                                [cpPosition]="'bottom'" [cpPositionRelativeToArrow]="'false'" [cpCancelButton]="'true'" [cpOKButton]="'true'" (colorPickerOpen)="'openDialog()'" [cpOutputFormat]="'rgba'" class="colorPicker form-control-plaintext">Color</span>
                                            <ng-container *ngIf="input.inputType == 'selectOption'">
                                                <select (change)="iconBehaviorHandler(input, $event, input['name'])" class="form-control" [value]="input['--value']">
                                                    <option *ngFor="let option of input.optionValues"
                                                        value="{{option.value}}">
                                                        {{option.label}}
                                                    </option>
                                                </select>
                                            </ng-container>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ng-container>
                </ul>
            </div>
            <div class="tab-pane fade" id="layout" role="tabpanel">
                <ul class="list-group">
                    <li class="list-group-item pr-3 pl-2 pb-2">
                        <a href="javascript:void(0)">Homepage Backgrounds</a>
                        <select class="custom-select_ form-control" id="homepage-bg" (change)="themeService.changeBackground($event.target.value)">
                            <option *ngFor="let background of bgs" [value]="background.value"
                                [selected]="selectedBackground == background.value">{{background.label}}</option>
                        </select>
                    </li>
                    <li class="list-group-item pr-3 pl-2 pb-2">
                        <a href="javascript:void(0)">Menu Position</a>
                        <select (change)="themeService.setToggleSidebar($event.target.value)" class="custom-select_ form-control">
                            <option value="">Select...</option>
                            <option value="1" [selected]="menuPosition == '1'">Left Menu Default (Default)</option>
                            <option value="2" [selected]="menuPosition == '2'">Top</option>
                        </select>
                    </li>
                    <li class="list-group-item pr-3 pl-2 pb-2">
                        <a href="javascript:void(0)">Dashboard</a>
                        <select (change)="changeDashboard($event.target.value)" class="custom-select_ form-control" [(ngModel)]="dashFlag" [ngModelOptions]="{standalone: true}">
                            <option value="1" [selected]="dashFlag == '1'">Dashboard 1</option>
                            <option value="2" [selected]="dashFlag == '2'">Dashboard 2</option>
                        </select>
                    </li>
                </ul>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <form id="themeForm">
                    <div class="opt_open form-inline">
                        <button type="button" title="Reset Current" class="btn btn-secondary" (click)="resetSCSSPropsHandler()">
                            <i class="fa fa-undo"></i>
                        </button>
                        <button type="button" title="Default Changes" class="btn btn-warning" (click)="setDefaultSCSSPropsHandler()">
                            <i class="fas fa-redo"></i>
                        </button>
                        <button type="button" title="Save Changes" class="btn btn-success" (click)="getCssProperties()">
                            <i class="fa fa-save"></i>
                        </button>
                        <button type="button" title="Close" class="btn btn-danger" (click)="close()">
                            <i class="fa fa-times"></i>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
